export type AgentDealerSelectSettings = {
  isAgent: boolean;
  employeeCounterpartId: number | null;
};

export const defaultAgentDealerSelectSettings: AgentDealerSelectSettings = {
  isAgent: true,
  employeeCounterpartId: null,
};
